import { render } from "./PowerCard.vue?vue&type=template&id=3207b585"
import script from "./PowerCard.vue?vue&type=script&lang=js"
export * from "./PowerCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__